/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Button, Card, CardHeader, CardTitle } from "@farmlands/shadcn-ui";
import { FC, useState } from "react";

import TestIds from "../../../../../testIds";
import DeleteAccountModal from "../DeleteAccountModal/DeleteAccountModal";

const DeleteAccountCard: FC = () => {
  const [displayDeleteAccountModal, setDisplayDeleteAccountModal] = useState<boolean>(false);

  return (
    <>
      <Card
        data-testid={TestIds.feat.account.profile.deleteAccountCard.component}
        className="gap-4"
      >
        <CardHeader className="gap-0">
          <CardTitle
            className={`flex w-full flex-wrap items-center justify-between gap-2 text-xl font-bold`}
          >
            <h2 className="text-md font-bold">Delete Account</h2>
            <Button
              variant="destructive-secondary"
              onClick={() => setDisplayDeleteAccountModal(true)}
              data-testid={TestIds.feat.account.profile.deleteAccountCard.deleteBtn}
            >
              Delete Account
            </Button>
          </CardTitle>
        </CardHeader>
      </Card>

      {displayDeleteAccountModal && (
        <DeleteAccountModal
          open={displayDeleteAccountModal}
          onOpenChange={setDisplayDeleteAccountModal}
        />
      )}
    </>
  );
};

export default DeleteAccountCard;
